import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import useAuthStore from '@/store/authStore';
import Logo from '@/components/ui/Logo';
import Input from '@/components/ui/Input';
import Button from '@/components/ui/Button';
import LanguageSwitcher from '@/components/ui/LanguageSwitcher';
import styles from '../Login/Login.module.css';

export default function ForgotPassword() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const forgotPassword = useAuthStore((s) => s.forgotPassword);

  const [email, setEmail] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    if (!email.trim()) {
      setError(t('auth.fillAll'));
      return;
    }
    setLoading(true);
    try {
      await forgotPassword(email.trim());
      navigate(`/reset-password?email=${encodeURIComponent(email.trim())}`);
    } catch (err) {
      setError(err.message || t('auth.invalidCredentials'));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className={styles.page}>
      <div className={styles.lang}>
        <LanguageSwitcher />
      </div>
      <form className={styles.card} onSubmit={handleSubmit}>
        <Logo size={40} />
        <p className={styles.tagline}>{t('auth.forgotSubtitle')}</p>

        <Input
          id="email"
          type="email"
          label={t('auth.email')}
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="voce@email.com"
          required
        />

        {error && <div className={styles.error}>{error}</div>}

        <Button type="submit" fullWidth loading={loading}>
          {t('auth.sendCode')}
        </Button>

        <p className={styles.hint}>{t('auth.forgotHint')}</p>

        <p className={styles.footer}>
          <button type="button" className={styles.linkMuted} onClick={() => navigate('/login')}>
            {t('auth.signIn')}
          </button>
        </p>
      </form>
    </div>
  );
}
